import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN;
const environment = process.env.REACT_APP_ENV || process.env.NODE_ENV;
const enabled =
  Boolean(dsn) &&
  (process.env.NODE_ENV === 'production' || process.env.REACT_APP_SENTRY_ENABLE_IN_DEV === 'true');

if (enabled) {
  Sentry.init({
    dsn,
    environment,
    // Keep tracing disabled by default. Set this env variable if you want performance traces.
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || 0),
  });
}

export { Sentry };
